// extracted by mini-css-extract-plugin
export default {"products":"Vt-z","card":"Wt-z","oosMessaging":"Xt-z"};